import React from "react";
// import Logo from "../../images/logo.png";
import MobileMenu from "../../components/MobileMenu";

import HeaderTopbar from "../HeaderTopbar";
import "./style.css";
import NavList from "../navlist";
// import Logo from "../Logo/Logo";
import logoMain from "../../images/logo-main.png";
import { useHistory } from "react-router-dom";

const Header = () => {
  const history = useHistory();
  return (
    <div className="middle-header">
      <HeaderTopbar />
      <div className="header-style-2">
        <div className="container-fluid">
          <div className="header-content">
            <div className="row align-items-center">
              <div className="col-xl-2 col-lg-2 col-md-4 col-sm-4 col-4">
                {/* <Logo /> */}
                <img
                  onClick={() => history.push("/")}
                  className="logo-image"
                  src={logoMain}
                  alt=""
                />
              </div>
              <NavList isHomepage={true} />
              <div className="col-md-8 col-sm-8 col-8">
                <MobileMenu />
              </div>
            </div>

            <div className="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
